export const OurTeam = [
    "Ionic is hybrid mobile application framework mainly concentrating on the UI interaction and its look and feel of your application for delivering highly interactive apps. Being an Ionic app development company, we deliver interactive and incredible cross-platform applications for Android and iOS with efficiency.",
    "We have highly experienced team of Ionic developers and guiding our customers by creating quality mobile apps that are flexible & expressive. Hire Ionic developer from us today and make your business successful.",
    "Our experienced developers and team leads work with you as a partner to understand your ideas & goals and improving the impact of your mobile app. As a experienced development company we are also able to help you across the full product development lifecycle till the delivery of your app."
]
export const OtherMobileServices = [
    {ul: [
        {li: "React Native development",
        path: "/services/react-native-development"},
        {li: "Flutter development",
        path: "/services/flutter-development"},
        {li: "PhoneGap development",
        path: "/services/phonegap-development"},
    ]}
]
export const OurWork = [
    "Our Ionic developers take Ionic framework to the next level. We developed lot of hybrid application in Ionic. We are one of the Ionic Framework experienced company in India.",
    "Our Ionic development team combines AngularJS with Ionic to release the full potential of the framework. Our Ionic developers have hands-on experiences and strong expertise on Ionic platform. They can handle all Ionic features and other cross-platform app frameworks.",
    "We trust that success of our customers is our success. We always discuss, listen and advice each other. We always hear to our client's wishes and discuss with them and plan accordingly to complete our objective on time. You can reach us and communicate with us very easily. We provide great customer support to our client. We are always available for you."
]
export const OurWorkList = [
"Enhance your productivity and give you a real competitive edge.",
"Experienced team of developers to guide what's best in trends for your business",
"We strive to provide superior customer service and ensure that every client is completely satisfied with our work.",
"We create high performance, Native-Like Mobile Apps with Ionic on Time and within your budget",
"Support your people and systems, as well as advise you on projects that will reduce your risk",
"We are committed to deliver outstanding, cutting edge IT solutions.",
"With our unmatched expertise and experience, hiring us is not one of the options but a choice of our clients.",
]
export const ionicPara = [
    "Start working with IStellar that can provide everything for your mobile apps."
]
export const IonicImg1 = [
    "IonicImg1"
]
export const IonicImg2 = [
    "IonicImg2"
]
export const cardServices = [
    {
        id: 1,
        title: "Cross-Platform Support",
        content: "Our developers use highly standard tools and technology with a single coding. We completely use the advantages of ionic to build cross platform mobile apps to give affordable and flexible apps to the businesses."
    }, {
        id: 2,
        title: "Highly Customizable User Interface",
        content: "Ionic Framework is developed in a combination of HTML, CSS, and JavaScript. That gives lots of customization options. The JavaScript and CSS features included in Angular will allow you to deliver the application with different color schemes, menus, buttons, etc."
    }, {
        id: 3,
        title: "Great Community Support",
        content: "The Ionic Framework has an extended and active community that is endlessly working to offer improvements and expand features. Every developer may need a help during their app development, and we can get guidance from many people in Ionic community."
    }, {
        id: 4,
        title: "Open Source",
        content: "The ionic framework is completely open source with CSS that gives parallel native feel on multiple operating systems. Due to its single code base nature, it reduces the efforts and time spent on changing the codes often. Integration of Angular/React with ionic gives excellent results."
    }, {
        id: 5,
        title: "Great User Experience",
        content: "Creating sensational and intuitive user experience in the mobile app is a no brainer. This is one of the major point of the success of an application. All the successful mobile applications have great user experience and easy-to-use user interfaces."
    }, {
        id: 6,
        title: "Ionic Apps are Easy to Develop",
        content: "Due to its simple coding requirements, developers love using Ionic. Developers already knew HTML, CSS and JavaScript very well can easily build Ionic mobile apps."
    }, {
        id: 7,
        title: "API development for Mobile App",
        content: "Most of the mobile apps need to store data and this requires a server/cloud based backend. We can build mobile app backends using ColdFusion, PHP, NodeJS, Python and .Net, whether this is just a CRUD API for creating and updating data or whether you need a more fully featured web app."
    }, {
        id: 8,
        title: "Ionic Maintenance & Support",
        content: "We offer integrated app maintenance service to make sure security patches are enforced and that the app is kept up to date with latest Ionic releases. In addition to proactive maintenance we also provide 24/7 support whenever you need it."
    }, {
        id: 9,
        title: "Cost Effective",
        content: "One of the most attractive advantages by ionic development is cost-effective cross mobile app development. With the same cost, we can deploy ionic mobile app in multiple platforms."
    }
]